module.exports = __webpack_public_path__ + "static/media/buxton-17.6642506f.jpg";